import { Action, createReducer, on } from '@ngrx/store';
import { fetchClientsListData, fetchClientsListSuccess, fetchClientsListFailure, blockClient, blockClientSuccess, blockClientFailure, addClient, addClientSuccess, addClientFailure, editClient, editClientSuccess, editClientFailure } from "./client.actions";
import { cloneDeep } from 'lodash';
import { ClientsModel } from '../../core/models/client.models';

export interface ClientState {
    clientdata: ClientsModel | null;
    loading: boolean;
    error: any;
}

export const initialState: ClientState = {
    clientdata: null,
    loading: false,
    error: null,
};

export const clientReducer = createReducer(
    initialState,

    // Client
    on(fetchClientsListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchClientsListSuccess, (state, { clientdata }) => {
        return { ...state, clientdata, loading: false };
    }),
    on(fetchClientsListFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(blockClient, (state) => ({ ...state, loading: true, error: null })),
    on(blockClientSuccess, (state, { userguid }) => {
        return { ...state, loading: false, error: null };
      }),
    on(blockClientFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(addClient, (state) => ({ ...state, loading: true, error: null })),
    on(addClientSuccess, (state, { client }) => {
        return { ...state, loading: false, error: null };
      }),
    on(addClientFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(editClient, (state) => ({ ...state, loading: true, error: null })),
    on(editClientSuccess, (state, { client }) => {
        return { ...state, client: client, loading: false, error: null };
      }),
    on(editClientFailure, (state, { error }) => ({ ...state, error, loading: false })),
);

// Selector
export function reducer(state: ClientState | undefined, action: Action) {
    return clientReducer(state, action);
}
